<template>
  <layout-full v-if="screenTooSmall">
    <div class="text-center p-4">
      We're sorry, but this page is not supported on this screen size.
      <br>
      <br>
      Please switch to a larger device.
    </div>
    <b-button class="link-light" variant="link" @click="$router.go(-1)">
      <i class="fas fa-hand-point-left"></i>
      go back
    </b-button>
  </layout-full>

  <b-container v-else-if="chromeless" class="page">
    <b-row>
      <b-container>
        <b-row>
          <b-col cols="12">
            <div class="page-main">
              <b-card class="content-wrapper">
                <slot/>
              </b-card>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-row>
  </b-container>

  <b-container v-else-if="basic" fluid class="page">
    <b-row>
      <b-container>
        <b-row>
          <b-col cols="12">
            <div class="page-main">
              <div class="page-header">
                <h1 class="page-title">
                  <slot name="header"/>
                </h1>
                <slot name="breadcrumbs"/>
              </div>
              <b-card class="content-wrapper">
                <slot/>
              </b-card>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-row>
  </b-container>

  <div v-else :class="{ active: sidebarIsActive }" class="page with-sidebar">
    <div class="sidebar-wrapper">
      <slot name="sidebar"/>
    </div>
    <b-container fluid>
      <b-row no-gutters>
        <b-col cols="12">
          <div class="page-main">
            <div class="page-header">
              <b-row>
                <b-col cols="4">
                  <h1 class="page-title">
                    <slot name="header"/>
                  </h1>
                </b-col>
                <b-col cols="8">
                  <slot name="buttons"/>
                </b-col>
              </b-row>
              <slot name="breadcrumbs"/>
            </div>
            <b-card class="content-wrapper">
              <slot/>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>

</template>

<script>
import { mapState } from 'vuex'
import layoutFull from './layout-full'

export default {
  components: {
    layoutFull
  },
  props: {
    basic: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    ...mapState('sidebar', {
      sidebarIsActive: 'active'
    }),
    ...mapState('config', {
      chromeless: 'chromeless'
    }),
    screenWidth () {
      return screen.width
    },
    screenTooSmall () {
      return this.$route.meta.admin && screen.width < 576 // bootstrap sm min
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/stylesheets/main.scss';
@import 'node_modules/bootstrap/scss/bootstrap-grid.scss';

.page.with-sidebar {
  padding-left: 70px;
  transition: all .4s ease 0s;

  .sidebar-wrapper {
    position: fixed;
    top: 60px;
    bottom: 0;
    z-index: 1000;
    padding: 0;
    padding-bottom: $spacing-md;
    overflow-x: hidden;
    overflow-y: auto;
    border-right: 1px solid $light-grey;
    background: $light-primary;
    height: 100%;
    margin-left: -70px;
    left: 70px;
    width: 70px;
    transition: all .4s ease 0s;
  }
}

.page.active {
  padding-left: 250px;

  .sidebar-wrapper {
    margin-left: -250px;
    left: 250px;
    width: 250px;
  }
}

.page {
  background: $light-secondary;
  min-height: 100%;
  padding-top: 60px;

  .page-main {
    padding: $spacing-md;
    padding-top: 0;

    .page-header {
      padding: $spacing-sm 0;

      h1 {
        margin: 0;
        padding: 0;
        font-size: 26px;
      }
    }

    .content-wrapper {
      box-shadow: 1px 1px 1px 0 $light-grey;
      margin-bottom: $spacing-sm;

      >.card-body {
        padding: $spacing-sm 0;
      }
    }
  }
}

@include media-breakpoint-down(xs) {
  .page-main {
    padding-bottom: $spacing-md;
    padding: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/templates/page.vue